/** Lib Imports */
import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import PropTypes from "prop-types";

/** CSS */
import "./DynamicTabs.scss";

const DynamicTabs = ({ tabs, activeIndex: controlledIndex, onTabChange, scrollable }) => {
  const [localIndex, setLocalIndex] = useState(0);

  const isControlled = controlledIndex !== undefined;
  const activeIndex = isControlled ? controlledIndex : localIndex;

  const handleChange = (e) => {
    isControlled ? onTabChange?.(e.index) : setLocalIndex(e.index);
  };

  const dropdownOptions = tabs.map((tab, idx) => ({
    label: tab.header,
    value: idx,
    icon: tab.icon,
  }));

  const selectedOption =
    dropdownOptions.find((opt) => opt.value === activeIndex) || dropdownOptions[0];

  const selectedOptionTemplate = (option, props) => {
    const current = option?.label ? option : selectedOption;
    if (current) {
      return (
        <div className="dynamic-tab-dropdown-selected">
          {current.icon && <i className={`${current.icon} mr-2`} />}
          <span>{current.label}</span>
        </div>
      );
    }
    return <span>{props?.placeholder || "Select Tab"}</span>;
  };

  const optionItemTemplate = (option) => {
    return (
      <div className="dynamic-tab-dropdown-item">
        {option.icon && <i className={`${option.icon} mr-2`} />}
        <span>{option.label}</span>
      </div>
    );
  };

  return (
    <div className={`dynamic-tabs-wrapper ${scrollable ? "scrollable-tabs" : ""}`}>
      <div className="dynamic-tabs-dropdown-wrapper">
        <Dropdown
          value={activeIndex}
          options={dropdownOptions}
          optionLabel="label"
          optionValue="value"
          onChange={(e) => {
            if (e.value !== undefined && e.value !== null) {
              handleChange({ index: e.value });
            }
          }}
          valueTemplate={selectedOptionTemplate}
          itemTemplate={optionItemTemplate}
          className="dynamic-tabs-mobile-dropdown w-full"
          panelClassName="dynamic-tabs-mobile-dropdown-panel"
        />
      </div>

      <TabView activeIndex={activeIndex} onTabChange={handleChange}>
        {tabs.map((tab) => (
          <TabPanel key={tab.header} header={tab.header} leftIcon={tab.icon}>
            {tab.content}
          </TabPanel>
        ))}
      </TabView>
    </div>
  );
};

DynamicTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
  activeIndex: PropTypes.number,
  onTabChange: PropTypes.func,
  scrollable: PropTypes.bool,
};

export default DynamicTabs;
